export default __webpack_public_path__ + "static/media/amex.e4235687.png";